module.exports = __webpack_public_path__ + "static/media/speechbubble-round.807006aa.svg";